import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Box, TextField, Button, CircularProgress } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br'; // Import for Brazilian locale

import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';


import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const parseBrazilianCurrency = (value) => {
    if (typeof value === 'string') {
        return parseFloat(value.replace(/\./g, '').replace(',', '.')); // Convert "300,50" to 300.50
    }
    return value;
};

// Validation Schema
const validationSchema = Yup.object({
    date: Yup.string()
        .required('A data é obrigatória')
        .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Data deve ser no formato DD/MM/YYYY'),
    value: Yup.number()
        .transform((value, originalValue) => parseBrazilianCurrency(originalValue)) // Apply custom parser
        .typeError('O valor deve ser numérico')
        .min(0.01, 'O valor deve ser maior que zero')
        .required('O valor é obrigatório'),
    obs: Yup.string()
});



const PaymentForm = (props) => {
    const { handleCancel, initialValuesForm, registerPaymentKit, isLoadingData, dataToEdit , resumePaymentData, totalPaid} = props;
    const MySwal = withReactContent(Swal);

    const onSubmit = async (values) => {
        const { kit_products, ...rest } = dataToEdit
        const newValues = { ...rest, ...values, ...resumePaymentData, ...totalPaid }
        const formData = JSON.stringify(newValues, null, 2);
        const response = await registerPaymentKit(formData)
        if (response.status === 201) {
            MySwal.fire("Feito", `Kit NúmeroSucesso!!`, "success").then(() => {
                // Code to execute after the alert is confirmed
                // For example, redirect to another page or refresh data
                // setValuesToSave([])
                // setOpenForm(false)
                // getKits()
                console.log('data: ', response)
            })
        }
        console.log('response')
    };

    const initialValuesHere = {
        date: dayjs().format('DD/MM/YYYY'), // Default to today's date,
        value: '',
        payment_method: '',
        obs: '',
    };


    const initialValues = initialValuesForm ? initialValuesForm : initialValuesHere


    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                <Form>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            maxWidth: '400px',
                            margin: '0 auto',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                gap: '50px'
                            }}
                        >
                            {/* Date Input */}
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br"

                            > {/* Set adapterLocale to 'pt-br' */}
                                <DatePicker
                                    label={"Data"}
                                    value={values.date ? dayjs(values.date, 'DD/MM/YYYY') : dayjs()} // 
                                    onChange={(newValue) => {
                                        const formattedDate = newValue ? newValue.format('DD/MM/YYYY') : ''; // Format as DD/MM/YYYY
                                        setFieldValue('date', formattedDate); // Update Formik's state
                                    }}
                                    onBlur={handleBlur}
                                    sx={{
                                        width: '200px',
                                        height: '40px',
                                        "& .MuiOutlinedInput-root": {
                                            // backgroundColor: "white", // Keep the background white
                                            "&.Mui-focused": {
                                                borderColor: "whitesmoke",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "whitesmoke", // Change label color on focus (optional)
                                                borderColor: "whitesmoke",
                                            },
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error={touched.date && Boolean(errors.date)}
                                            helperText={touched.date && errors.date}
                                        />
                                    )}
                                />
                            </LocalizationProvider>

                            {/* Value Input */}
                            <TextField
                                label="Valor"
                                name="value"
                                value={values.value}
                                onChange={handleChange}
                                // onChange={(e) => {
                                //     const rawValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                //     const formattedValue = new Intl.NumberFormat('pt-BR', {
                                //         style: 'currency',
                                //         currency: 'BRL',
                                //     }).format(rawValue / 100); // Format as currency
                                //     setFieldValue('value', formattedValue);
                                // }}
                                onBlur={handleBlur}
                                error={touched.value && Boolean(errors.value)}
                                helperText={touched.value && errors.value}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        // backgroundColor: "white", // Keep the background white
                                        "&.Mui-focused": {
                                            borderColor: "whitesmoke",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "whitesmoke", // Change label color on focus (optional)
                                            borderColor: "whitesmoke",
                                        },
                                    },
                                }}
                            />
                        </Box>
                        <FormControl fullWidth>
                            <InputLabel id="payment-method-label">Forma de Pagamento</InputLabel>
                            <Select
                                labelId="payment-method-label"
                                name="payment_method"
                                value={values.payment_method || ''} // Default to empty
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.payment_method && Boolean(errors.payment_method)}
                            >
                                <MenuItem value="">Selecione uma opção</MenuItem>
                                <MenuItem value="01">Dinheiro</MenuItem>
                                <MenuItem value="03">Cartão de Crédito</MenuItem>
                                <MenuItem value="17">PIX – Dinâmico</MenuItem>
                                <MenuItem value="20">PIX – Estático</MenuItem>
                                <MenuItem value="99">Outros</MenuItem>
                            </Select>
                        </FormControl>

                        {/* Observation Input */}
                        <TextField
                            label="Observações"
                            name="obs"
                            value={values.obs}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            multiline
                            rows={3}
                            error={touched.obs && Boolean(errors.obs)}
                            helperText={touched.obs && errors.obs}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    // backgroundColor: "white", // Keep the background white
                                    "&.Mui-focused": {
                                        borderColor: "whitesmoke",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "whitesmoke", // Change label color on focus (optional)
                                        borderColor: "whitesmoke",
                                    },
                                },
                            }}
                        />
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-end',
                                gap: '10px'
                            }}
                        >
                            {/* Submit Button */}
                            <Button onClick={handleCancel} variant="contained" color="warning" sx={{ width: '50%', color: 'whitesmoke' }}>
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="success"
                                sx={{ width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'whitesmoke' }}
                                disabled={isLoadingData} // Disable the button while loading
                            >
                                {isLoadingData ? <CircularProgress size={24} color="inherit" /> : 'Salvar'}
                            </Button>
                        </Box>
                    </Box>
                </Form>
            )}
        </Formik>
    );
}

export default PaymentForm